/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/apiConnectionBar.scss';

import React, {MouseEventHandler, useContext, useMemo} from 'react';

import {useTranslation} from 'react-i18next';

import {AppContext} from '../misc/appContext';

import {AccessKey, ApiKeyStatus} from '../../util/interfaces';

import {BolmateButton} from '../controls';

import {AwesomeIcon} from '@dvrd/dvr-controls';

import useRight from '../misc/useRight';

import ApiKey from '../../models/apiKeyModel';

interface Props {
    onClickApiFlow: MouseEventHandler;
}

export default function APIConnectionBar(props: Props) {
    const {t} = useTranslation();
    const context = useContext(AppContext);
    const {account} = context.accountContext;
    const [canSetupAPI] = useRight(AccessKey.API_SETTINGS_SETUP);
    const {onClickApiFlow} = props;
    const visible = useMemo(() => {
        if (!account || !canSetupAPI) return false;
        return !account.apiKeys.find((apiKey: ApiKey) =>
            [ApiKeyStatus.ACTIVE, ApiKeyStatus.IMPORTING].includes(apiKey.status)
        );
    }, [account, canSetupAPI]);

    if (!visible) return null;
    return (
        <div className='api-connection-bar'>
            <BolmateButton
                onClick={onClickApiFlow}
                label={t('dashboard.apiConnectionBar.connectWithBol', 'Koppelen met Bol')}
                ornaments={{element: <AwesomeIcon name='link' />}}
            />
        </div>
    );
}
